module.exports = __webpack_public_path__ + "img/66.4.NH3-N.17fc0ce2.png";